import React from "react";
import { useTranslation } from "react-i18next";
import FormLayout from "../../averagePrices/FormLayout/FormLayout";
import DetailedCheckbox from "../../averagePrices/form/DetailedCheckbox/DetailedCheckbox";
import { Checkbox } from "../../common";

const getRegionName = id => `region_${id}`;
export const mapFormValuesToRegionIds = values =>
  Object.entries(values)
    .filter(([key]) => key.startsWith("region_"))
    .filter(([, value]) => value === true)
    .map(([key]) => key.replace("region_", ""))
    .map(Number);

const RaportForm = ({ listOfRegions, settings, setSettings }) => {
  const { t, i18n } = useTranslation(["averagePrices"]);

  const handleRegionChange = regionId => {
    // check if id already exist in case it does remove it else add it
    const newRegions = settings.regions.includes(regionId)
      ? settings.regions.filter(id => id !== regionId)
      : [...settings.regions, regionId];
    setSettings({ ...settings, regions: newRegions });
  };
  const handleToggleAllRegions = () => {
    const newRegions =
      settings.regions.length === listOfRegions.length ? [] : listOfRegions;
    setSettings({ ...settings, regions: newRegions });
  };

  return (
    <FormLayout>
      <FormLayout.Fieldset
        title={t("averagePrices:poultryPage.form.fieldsetRegion")}
      >
        <FormLayout.DetailedCheckboxes>
          <div className="toggle-all">
            <Checkbox
              label={t("averagePrices:selectAll")}
              name="toggle_all"
              onChange={handleToggleAllRegions}
              checked={settings.regions.length === listOfRegions.length}
              id="toggle_all"
            />
          </div>
          {listOfRegions.map(region => (
            <DetailedCheckbox
              key={region.id}
              name={getRegionName(region.id)}
              label={
                i18n.language === "pl"
                  ? `${region.name.charAt(0).toUpperCase() +
                      region.name.slice(1)}`
                  : region.name_en
              }
              details={region.subregions.join(", ")}
              checked={settings.regions.map(({ id }) => id).includes(region.id)}
              onChange={() => handleRegionChange(region)}
            />
          ))}
        </FormLayout.DetailedCheckboxes>
      </FormLayout.Fieldset>
    </FormLayout>
  );
};

export default RaportForm;
